import React from 'react';
import { Box } from '@mui/material';
import CongratulationCard from '../../Common/CongratulationCard';

const SuccessPage: React.FC = () => {
  return (
    <Box className="congratulation-card--wrapper">
      <CongratulationCard message={'You have successfully changed your password'} />
    </Box>
  );
};

export default SuccessPage;
